import { render, staticRenderFns } from "./modalPedidoDelete.vue?vue&type=template&id=5c9c1eec&scoped=true&"
import script from "./modalPedidoDelete.vue?vue&type=script&lang=js&"
export * from "./modalPedidoDelete.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/modal.css?vue&type=style&index=0&id=5c9c1eec&scoped=true&lang=css&"
import style1 from "./modalPedidoDelete.vue?vue&type=style&index=1&id=5c9c1eec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9c1eec",
  null
  
)

export default component.exports